import { z } from "zod";

// Common validation schemas used across the API

export const uuidSchema = z.uuid();

/** Relaxed UUID format for AWS Cognito `sub` claims which may not follow RFC 4122 variant bits */
export const cognitoUuid = z.string().regex(
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i,
  "Invalid UUID format"
);

export const nameSchema = z.string().trim().min(1).max(255);

export const emailSchema = z.string().email().max(255);

export const dateSchema = z.coerce.date();

export const positiveIntSchema = z.number().int().positive();

export const nonNegativeIntSchema = z.number().int().nonnegative();


